import { Component, Input, OnInit } from '@angular/core';
import { HomeService } from '../home/home.services';
import { BusinessCaseService } from '../settings/business-case/business-case.service';
import { ActivatedRoute } from '@angular/router';
import { Setting } from 'src/app/shared/models/settings.models';
import { ZeroBusinessCase } from 'src/app/shared/models/businessCase';
import { BusinessCase } from 'src/app/shared/models/businessCase';

@Component({
  selector: 'app-business-case-display',
  templateUrl: './business-case-display.component.html',
  styleUrl: './business-case-display.component.scss'
})
export class BusinessCaseDisplayComponent implements OnInit {
  submolecules: any[];
  subMolecule = false;
  selectedSubMolecule: any;
  Molecule = false;
  DragData: any = {};
  noData = false;
  settings: Setting[];
  cols: any[];
  businessCase: BusinessCase[];
  zeroBusinessData: ZeroBusinessCase[];
  public columns: { header: Array<any>; data: Array<any> };
  settinglist: any;
  total = 0;
  total1 = 0;
  total2 = 0;
  total3 = 0;
  total4 = 0;
  total5 = 0;
  total6 = 0;
  total7 = 0;
  total8 = 0;
  total9 = 0;
  total10 = 0;
  private value;
  @Input() olddata: any;
  strength: any;
  growth: any;
  initialValues: any;
  marketShare: any;
  rld_price: unknown[];
  rld_strength: any;
  priceErosion_strength: any;
  priceErosion_fillVolume: any;
  launch_year: any;
  year_1: any;
  year_2: any;
  year_3: any;
  final_year: any;
  npvData: any;
  therapeuticClass: any;
  show = false;
  showIntialValue = false;
  showFutureFillVol = false;
  showGrowthFillVol = false;
  showMarketFillVol = false;
  showRLDFillVol = false;
  showLaunchFillVol = false;
  showCogsFillVol = false;
  showErosionFillVol = false;
  showMarketStrength = false;
  showMarketShare = false;
  showMarketYear1 = false;
  showMarketYear2 = false;
  showMarketYear3 = false;
  showMarketfinal = false;
  showRldstrength = false;
  showRldvalues = false;
  showPriceErosionStrength = false;
  showLaunchYear = false;
  showYear1 = false;
  showYear2 = false;
  showYear3 = false;
  showFinalYear = false;
  showMarketStrengthlaunch = false;
  Cogs: any;
  launch_year_market: any;
  showMarketLaunchYear = false;
  showCogsStrength = false;
  showFinalCogs = false;
  showApiDatabase = false;
  showOverhead = false;
  showRMPMBox5 = false;
  showTheraputicClass = false;
  apiPrice: any;
  peakYear: any;
  peakSalesInput: any;
  capex: any;
  peakSalesOutput: any;
  logistics: any;
  sga: any;
  Insurance: any;
  wacc: any;
  tax: any;
  expected_entrants: any;
  showApiPrice = false;
  showpeakYear = false;
  showCapex = false;
  showPeakSalesInput = false;
  showPeakSalesOutput = false;
  showLogistics = false;
  showSga = false;
  showWacc = false;
  showTax = false;
  showInsurance = false;
  showExpectedEntrance = false;
  showExpectedANDA = false;
  showExpectedTentative = false;
  showExpectedFiled = false;
  showExpectedEntrants = false;
  showExpectedAll = false;
  dataNA: any;
  businessData: any;
  firstTable: any;
  showGrowth = false;
  showGrowthStrength = false;
  final_val: any;
  total_players: any;
  launch_val: any;
  rate_decline: any;
  price_erosion_rld: any;
  yr2_val: any;
  yr3_val: any;
  yr4_val: any;
  paramsValues: any;
  email: any;
  isFillVolumeAvailable: any;
  isFillVolumeGrowth: any;
  isFillVolumeMarketShare: any;
  isFillVolumeRLD: any;
  isFillVolumePriceEro: any;
  isFillVolumeLaunchYear: any;
  isFillVolumeCogs: any;

  disable = false;
  constructor(
    private homeservice: HomeService,
    private businessService: BusinessCaseService,
    private route: ActivatedRoute,
  ) {
    this.submolecules = [];

    this.cols = [
      { field: "variable", header: "Variable" },
      { field: "value", header: "Value" },
    ];
  }

  ngOnInit(): void {
    this.email = localStorage.getItem("email");
    this.getFirstTableData();
  }

  getFirstTableData() {
    if(this.olddata){
      const resp = this.olddata;

      this.firstTable = resp["Custom_values"];
      if (resp === "N/A") {
        this.getBusinessCase_NA_DATA();
      } else {
        this.getBusinessCaseData();
      }
      this.strength = resp["Custom_values"]["Future_Volume_Growth/Degrowth"]; //Future Volume Growth
      this.isFillVolumeAvailable = this.strength.some(item =>
        item.hasOwnProperty('Fill Volume/Weight (ml or gm)')
      )
      this.growth = resp["Custom_values"]["Growth"]; //Growth
      this.isFillVolumeGrowth = this.growth.some(item =>
        item.hasOwnProperty('Fill Volume/Weight (ml or gm)')
      )
      this.marketShare = resp["Custom_values"]["Market_Share_percent"]; //Market Share
      this.isFillVolumeMarketShare =
        Array.isArray(this.marketShare) && this.marketShare.some(item =>
          item.hasOwnProperty('Fill Volume/Weight (ml or gm)')
        );
      this.rld_price = resp["Custom_values"]["RLD_Price_Increase"]; // RLD Price
      console.log("rld_price=========", this.rld_price)
      this.isFillVolumeRLD = this.rld_price.some(item =>
        item.hasOwnProperty('Fill Volume/Weight (ml or gm)')
      )
      // Price Erosion
      this.priceErosion_strength = resp["Custom_values"]["Price_Erosion"];
      this.isFillVolumePriceEro =
        resp["Custom_values"]["Price_Erosion"].hasOwnProperty('Fill Volume/Weight (ml or gm)') &&
        resp["Custom_values"]["Price_Erosion"]["Fill Volume/Weight (ml or gm)"].length > 0;
        this.priceErosion_fillVolume = resp["Custom_values"]["Price_Erosion"]["Fill Volume/Weight (ml or gm)"];
        this.launch_year = resp["Custom_values"]["Price_Erosion"]?.launch_year;
        this.year_1 = resp["Custom_values"]["Price_Erosion"]["year 1"];
        this.year_2 = resp["Custom_values"]["Price_Erosion"]["year 2"];
        this.year_3 = resp["Custom_values"]["Price_Erosion"]["year 3"];
        this.final_year = resp["Custom_values"]["Price_Erosion"].final_year;
        this.total_players = resp["Custom_values"]["Price_Erosion"].total_players;
        this.final_val = resp["Custom_values"]["Price_Erosion"].final_val;
        this.launch_val = resp["Custom_values"]["Price_Erosion"].launch_val;
        this.rate_decline =
          resp["Custom_values"]["Price_Erosion"].rate_of_decline;
        this.price_erosion_rld =
          resp["Custom_values"]["Price_Erosion"]["rld price"];
        this.yr2_val = resp["Custom_values"]["Price_Erosion"].yr2_val;
        this.yr3_val = resp["Custom_values"]["Price_Erosion"].yr3_val;
        this.yr4_val = resp["Custom_values"]["Price_Erosion"].yr4_val;
        // this.launch_year_market = resp["Custom_values"]["launch_year"];  // Hide in Dev
        this.therapeuticClass = resp["Custom_values"]["Therapeutic_category"];
        this.Cogs = resp["Custom_values"]["Cogs"];
        this.isFillVolumeCogs = this.Cogs.some(item =>
          item.hasOwnProperty('Fill Volume/Weight (ml or gm)')
        )
        this.apiPrice = resp["Custom_values"]["API_Price_USD_PER_KG"];
        this.peakYear = resp["Custom_values"]["Peak_Year"];
        this.capex = resp["Custom_values"]["Capex"];
        this.peakSalesInput = resp["Custom_values"]["Peak_Sales_Input"];
        this.peakSalesOutput = resp["Custom_values"]["Peak_Sales_Output"];
        this.logistics = resp["Custom_values"]["Logistics"];
        this.sga = resp["Custom_values"]["SG_A"];
        this.Insurance = resp["Custom_values"]["Insurance & Rebates"];
        this.wacc = resp["Custom_values"]["WACC"];
        this.tax = resp["Custom_values"]["Tax"];
        this.expected_entrants = resp["NPV_IRR"]["Expected_entrants"];
        this.launch_year_market = resp["NPV_IRR"]["Launch_year"];
        this.isFillVolumeLaunchYear = Array.isArray(this.launch_year_market) && this.launch_year_market.some(item =>
          item.hasOwnProperty('Fill Volume/Weight (ml or gm)')
        )
    }
  }

  getBusinessCaseData() {
  
    this.organizeTheData(this.olddata['Business_case_result']);
    this.businessCase = this.olddata['Business_case_result'];
    this.findsum(this.olddata['Business_case_result']);
    this.npvData = this.olddata['NPV_IRR'];

  }

  getBusinessCase_NA_DATA() {
    this.organizeTheData(this.olddata['Business_case_result']);
    this.findsum(this.olddata['Business_case_result']);
    this.npvData = this.olddata['NPV_IRR'];
    this.businessCase= this.olddata['Business_case_result'];

    
  }
  private organizeTheData(business) {
    const header = [];
    const data = [];
    business.forEach((row: any) => {
      header.push(row.year);
      data.push(row);
    });
    this.columns = { header, data };
  }

  findsum(data) {
    this.value = data;
    for (let j = 0; j < data.length; j++) {
      this.total += this.value[j].Revenue;
      this.total1 += this.value[j].COGs;
      this.total2 += this.value[j].GM;
      this.total3 += this.value[j].OPEX;
      this.total4 += this.value[j].EBITDA;
      this.total5 += this.value[j].Insurance;
      this.total6 += this.value[j].Logistics;
      this.total7 += this.value[j].NetTax;
      this.total8 += this.value[j].PAT;
      this.total9 += this.value[j].PBT;
      this.total10 += this.value[j].SGA;
    }
  }

  getSetting() {
    this.businessService.getSettings().then((data) => (this.settings = data));
  }
}
